import React from 'react'
import { ReferenceArrayInput, SelectInput, required, FormDataConsumer } from 'react-admin'
import PropTypes from 'prop-types'

const MbtisReferenceInput = ({ source, field }) => (
  <FormDataConsumer>
    {({ formData }) => (
      <ReferenceArrayInput
        label="resources.answers_skills.fields.mbti_value"
        source={source}
        resource={source}
        reference="types/mbtis"
        disabled={formData && formData[field] ? false : true}
        filter={{ axis: formData ? [formData[field]] : null }}
        perPage={100}
        validate={[required()]}
      >
        <SelectInput optionText="value" />
      </ReferenceArrayInput>
    )}
  </FormDataConsumer>  
)

MbtisReferenceInput.propTypes = {
  field: PropTypes.string,
  source: PropTypes.string
}

export default MbtisReferenceInput
